

// import { useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { Canvas } from '@react-three/fiber';
// import { OrbitControls, Box } from '@react-three/drei';
// import { FiLogIn, FiUser, FiShoppingCart } from 'react-icons/fi';
// import logo from '../assets/logo.png'; // Placeholder for logo

// // 3D Logo Component
// const Logo3D = () => {
//   return (
//     <Canvas camera={{ position: [0, 0, 5], fov: 45 }}>
//       <ambientLight intensity={0.5} />
//       <pointLight position={[10, 10, 10]} />
//       <Box args={[3, 3, 3]} rotation={[0.5, 0.5, 0]}>
//         <meshStandardMaterial color="#722d04ff" />
//       </Box>
//       <OrbitControls enableZoom={false} autoRotate autoRotateSpeed={2} />
//     </Canvas>
//   );
// };

// function Home() {
//   const navigate = useNavigate();

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 flex flex-col items-center justify-center p-4">
//       {/* Animated 3D Logo */}
//       <motion.div
//         initial={{ scale: 0 }}
//         animate={{ scale: 1 }}
//         transition={{ type: 'spring', stiffness: 200 }}
//         className="w-40 h-40 mb-6"
//       >
//         <Logo3D />
//       </motion.div>

//       {/* Company Logo */}
//       <motion.img
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.3 }}
//         src={logo}
//         alt="Symax Logo"
//         className="w-62 mb-6 rounded-full border-4 border-white shadow-lg"
//       />

//       {/* Main Heading */}
//       <motion.h1
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.4 }}
//         className="text-5xl font-bold bg-gradient-to-r from-red-600 to-indigo-600 bg-clip-text text-transparent mb-10 text-center"
//       >
//         Firstaid-pro Tracking and Training System
//       </motion.h1>

//       {/* Login Buttons */}
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ delay: 0.5 }}
//         className="space-y-6 w-full max-w-md"
//       >
//         <motion.button
//           whileHover={{ scale: 1.03 }}
//           whileTap={{ scale: 0.98 }}
//           onClick={() => navigate('/admin-login')}
//           className="w-full bg-gradient-to-r from-orange-600 to-indigo-600 text-white py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3"
//         >
//           <FiUser size={20} />
//           Login as Admin
//         </motion.button>

//         <motion.button
//           whileHover={{ scale: 1.03 }}
//           whileTap={{ scale: 0.98 }}
//           onClick={() => navigate('/user-login')}
//           className="w-full bg-gradient-to-r from-gray-600 to-orange-700 text-white py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3"
//         >
//           <FiUser size={20} />
//           Login as User
//         </motion.button>

//         {/* Demo Access Button */}
        
//       </motion.div>

//       {/* Footer */}
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ delay: 0.8 }}
//         className="mt-12 text-gray-500 text-sm"
//       >
//         © {new Date().getFullYear()} Firstaid-pro Management System All rights reserved. Developed by Zacharia.
//       </motion.div>
//     </div>
//   );
// }

// export default Home;

import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Sphere } from '@react-three/drei';
import { FiLogIn, FiUser, FiShoppingCart, FiArrowRight } from 'react-icons/fi';
import { useEffect, useRef, useState } from 'react';
import logo from '../assets/logo.png'; // Placeholder for logo

// Enhanced 3D Logo Component with particles
const Logo3D = () => {
  return (
    <Canvas camera={{ position: [0, 0, 8], fov: 50 }}>
      <ambientLight intensity={0.4} />
      <directionalLight position={[10, 10, 5]} intensity={1} />
      <pointLight position={[10, 10, 10]} intensity={1.5} />
      <Sphere args={[1.8, 32, 32]} rotation={[0.5, 0.5, 0]}>
        <meshStandardMaterial 
          color="#3b82f6" 
          metalness={0.8} 
          roughness={0.2} 
          transparent 
          opacity={0.9}
        />
      </Sphere>
      <OrbitControls 
        enableZoom={false} 
        autoRotate 
        autoRotateSpeed={3} 
        enablePan={false}
      />
    </Canvas>
  );
};

// Particle background component
const ParticleBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden z-0">
      {[...Array(30)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-1 h-1 bg-blue-500 rounded-full"
          initial={{
            x: Math.random() * 100 + 'vw',
            y: Math.random() * 100 + 'vh',
            scale: Math.random() * 0.5 + 0.5,
          }}
          animate={{
            x: Math.random() * 100 + 'vw',
            y: Math.random() * 100 + 'vh',
            transition: {
              duration: Math.random() * 10 + 10,
              repeat: Infinity,
              repeatType: 'reverse',
            },
          }}
        />
      ))}
    </div>
  );
};

// Glowing orb component for background
const GlowingOrbs = () => {
  return (
    <>
      <motion.div 
        className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-blue-500 opacity-20 blur-3xl"
        animate={{
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
        }}
      />
      <motion.div 
        className="absolute bottom-1/3 right-1/4 w-80 h-80 rounded-full bg-purple-500 opacity-20 blur-3xl"
        animate={{
          scale: [1.2, 1, 1.2],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
        }}
      />
    </>
  );
};

function Home() {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(null);
  const containerRef = useRef(null);

  // Mouse move effect for interactive background
  useEffect(() => {
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const x = clientX / window.innerWidth;
      const y = clientY / window.innerHeight;
      
      if (containerRef.current) {
        containerRef.current.style.setProperty('--mouse-x', x);
        containerRef.current.style.setProperty('--mouse-y', y);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div 
      ref={containerRef}
      className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 flex flex-col items-center justify-center p-4 relative overflow-hidden"
      style={{
        '--mouse-x': 0.5,
        '--mouse-y': 0.5,
      }}
    >
      {/* Interactive gradient based on mouse position */}
      <div 
        className="absolute inset-0 opacity-40 transition-opacity duration-500"
        style={{
          background: `radial-gradient(circle at calc(var(--mouse-x, 0.5) * 100%) calc(var(--mouse-y, 0.5) * 100%), rgba(59, 130, 246, 0.4), transparent 50%)`,
        }}
      />
      
      <ParticleBackground />
      <GlowingOrbs />
      
      {/* Animated grid background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-grid-pattern bg-center bg-cover"></div>
      </div>

      {/* Animated 3D Logo */}
      <motion.div
        initial={{ scale: 0, rotateY: 180 }}
        animate={{ scale: 1, rotateY: 0 }}
        transition={{ type: 'spring', stiffness: 100, damping: 10 }}
        className="w-48 h-48 mb-8 relative z-10"
        whileHover={{ 
          scale: 1.05,
          rotateY: 10,
          transition: { duration: 0.5 }
        }}
      >
        <Logo3D />
        <motion.div 
          className="absolute inset-0 rounded-full border-2 border-blue-400 opacity-70"
          animate={{
            boxShadow: [
              "0 0 20px rgba(59, 130, 246, 0.5)",
              "0 0 40px rgba(59, 130, 246, 0.8)",
              "0 0 20px rgba(59, 130, 246, 0.5)"
            ]
          }}
          transition={{ duration: 3, repeat: Infinity }}
        />
      </motion.div>

      {/* Company Logo */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="relative z-10 mb-8"
      >
        <motion.img
          src={logo}
          alt="Symax Logo"
          className="w-64 mb-2 rounded-full border-4 border-white/20 shadow-2xl backdrop-blur-sm"
          whileHover={{ 
            scale: 1.05,
            borderColor: "rgba(255, 255, 255, 0.4)",
            transition: { duration: 0.3 }
          }}
        />
        <motion.div 
          className="absolute -inset-4 rounded-full border-2 border-blue-400/50"
          animate={{
            rotate: 360,
            transition: { duration: 20, repeat: Infinity, ease: "linear" }
          }}
        />
      </motion.div>

      {/* Main Heading */}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent mb-8 text-center relative z-10"
      >
        <motion.span
          animate={{ backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'] }}
          transition={{ duration: 8, repeat: Infinity }}
          style={{ 
            backgroundSize: '200% 200%',
          }}
          className="bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent"
        >
          Firstaid-pro
        </motion.span>
        <br />
        <span className="text-2xl md:text-3xl font-light text-white/80 mt-2 block">
          Tracking and Training System
        </span>
      </motion.h1>

      {/* Login Buttons */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="space-y-6 w-full max-w-md relative z-10"
      >
        <motion.button
          whileHover={{ 
            scale: 1.03,
            boxShadow: "0 0 25px rgba(59, 130, 246, 0.5)"
          }}
          whileTap={{ scale: 0.98 }}
          onHoverStart={() => setIsHovered('admin')}
          onHoverEnd={() => setIsHovered(null)}
          onClick={() => navigate('/admin-login')}
          className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-xl text-lg font-semibold shadow-2xl hover:shadow-xl transition-all flex items-center justify-center gap-3 relative overflow-hidden group"
        >
          <motion.span
            animate={isHovered === 'admin' ? { x: [0, 5, 0] } : { x: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-3"
          >
            <FiUser size={20} />
            Login as Admin
          </motion.span>
          <motion.div 
            className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            initial={false}
            animate={{ x: isHovered === 'admin' ? '0%' : '-100%' }}
            transition={{ duration: 0.5 }}
          />
          <motion.div 
            className="absolute right-4"
            initial={{ x: -20, opacity: 0 }}
            animate={{ 
              x: isHovered === 'admin' ? 0 : -20, 
              opacity: isHovered === 'admin' ? 1 : 0 
            }}
            transition={{ duration: 0.3 }}
          >
            <FiArrowRight />
          </motion.div>
        </motion.button>

        <motion.button
          whileHover={{ 
            scale: 1.03,
            boxShadow: "0 0 25px rgba(239, 68, 68, 0.5)"
          }}
          whileTap={{ scale: 0.98 }}
          onHoverStart={() => setIsHovered('user')}
          onHoverEnd={() => setIsHovered(null)}
          onClick={() => navigate('/user-login')}
          className="w-full bg-gradient-to-r from-purple-600 to-rose-600 text-white py-4 rounded-xl text-lg font-semibold shadow-2xl hover:shadow-xl transition-all flex items-center justify-center gap-3 relative overflow-hidden group"
        >
          <motion.span
            animate={isHovered === 'user' ? { x: [0, 5, 0] } : { x: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-3"
          >
            <FiUser size={20} />
            Login as User
          </motion.span>
          <motion.div 
            className="absolute inset-0 bg-gradient-to-r from-purple-500 to-rose-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            initial={false}
            animate={{ x: isHovered === 'user' ? '0%' : '-100%' }}
            transition={{ duration: 0.5 }}
          />
          <motion.div 
            className="absolute right-4"
            initial={{ x: -20, opacity: 0 }}
            animate={{ 
              x: isHovered === 'user' ? 0 : -20, 
              opacity: isHovered === 'user' ? 1 : 0 
            }}
            transition={{ duration: 0.3 }}
          >
            <FiArrowRight />
          </motion.div>
        </motion.button>
      </motion.div>

      {/* Demo Access Button */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
        className="mt-8 relative z-10"
      >
        <button
          onClick={() => navigate('/demo')}
          className="text-white/70 hover:text-white text-sm font-light border-b border-transparent hover:border-white/50 transition-all duration-300"
        >
          
        </button>
      </motion.div>

      {/* Footer */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
        className="mt-12 text-white/40 text-sm relative z-10 text-center"
      >
        <p>© {new Date().getFullYear()} Firstaid-pro Management System</p>
        <p>All rights reserved. Developed by Zacharia.</p>
      </motion.div>
    </div>
  );
}

export default Home;